import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Socket from "socket";
import * as loaderAction from "../../../../redux/loader/action";
import TopBar from "./componentss/TopBar";
import BottomNav from "./componentss/BottomNav";
import SlidekickOnly from "./componentss/SlidekickOnly";
import HeroAndSlidekick from "./componentss/HeroAndSlidekick";

const PresenterPresenting = (props) => {
  const room_data = _.get(props, "gameReducer.roomObj");
  const slidekick_url = _.get(room_data, "game_state.slidekick_url");
  const hero_url = _.get(room_data, "game_state.hero_url");
  const deck_size = _.get(room_data, "game_state.deck_size");
  const current_slide = _.get(room_data, "game_state.current_slide");
  const slide_type = _.get(room_data, "game_state.slide_type");
  const slidekick_only = _.get(room_data, "game_state.slidekick_only");
  const [active_slide, set_active_slide] = useState(current_slide);
  const [goto_disable, set_goto_disable] = useState(false);

  useEffect(() => {
    set_active_slide(current_slide);
    props.setIsLoading(false);
  }, [current_slide]);

  useEffect(() => {
    if (active_slide === current_slide) {
      set_goto_disable(true);
    } else {
      set_goto_disable(false);
    }
  }, [active_slide, current_slide]);

  useEffect(() => {
    return Socket.addListener("change-slide", turn_off_loader, log_on_error);
  }, []);

  const turn_off_loader = () => {
    props.setIsLoading(false);
  };

  const log_on_error = (err) => {
    console.log(err, "errerrerrerr");
  };

  const change_slide = (slideAction) => {
    props.setIsLoading(true);
    const data = {
      action: "change-slide",
      roomId: room_data.id,
      userId: room_data.host_user_id,
      slideAction,
    };
    Socket.sendMessage(data);
  };

  const handle_go_to_slide = async () => {
    props.setIsLoading(true);
    const data = {
      action: "change-slide",
      roomId: room_data.id,
      userId: room_data.host_user_id,
      slideAction: "goto",
      slideNumber: active_slide,
    };
    Socket.sendMessage(data);
  };

  return (
    <>
      <TopBar end_slides_button={"End Slides"} />
      {slidekick_only ? (
        <SlidekickOnly
          slidekick_url={slidekick_url}
          hero_url={hero_url}
          active_slide={active_slide}
          set_active_slide={set_active_slide}
          deck_size={deck_size}
          slidekick_only={slidekick_only}
          slide_type={slide_type}
        />
      ) : (
        <HeroAndSlidekick
          slidekick_url={slidekick_url}
          hero_url={hero_url}
          active_slide={active_slide}
          set_active_slide={set_active_slide}
          deck_size={deck_size}
          slidekick_only={slidekick_only}
          slide_type={slide_type}
        />
      )}
      <BottomNav
        current_slide={current_slide}
        total_pages={deck_size}
        change_slide={change_slide}
        handle_go_to_slide={handle_go_to_slide}
        goto_disable={goto_disable}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PresenterPresenting);
